import { getApiEndpoint } from '~/api/auth';
import type { Topic, TopicWithProject } from '~/api/types.ts';
import { authFetch } from '~/api/utils';

export const getTopics = async (): Promise<Topic[]> => {
  return await authFetch<Topic[]>(getApiEndpoint() + 'topics/', {
    method: 'GET',
  });
};

export const getTopic = async (slug: string): Promise<TopicWithProject> => {
  return await authFetch(getApiEndpoint() + 'topics/' + slug, {
    method: 'GET',
  });
};
